import { createCustomer, updateCustomer } from "store/actions/customer-action";
import { AppDispatch, RootState } from "store/store";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useRef } from "react";
import { uploadImage } from "store/actions/common-action";

export default ({ data, mode }) => {
    const dispatch: AppDispatch = useDispatch();
    const navigate = useNavigate();
    const fileInputRef = useRef(null);

    const { user, common_loading } = useSelector((state: RootState) => state.common);


    const handleImageChange = (e, setFieldValue) => {
        const file = e.target.files[0];
        if (file) {

            const reader = new FileReader();

            reader.onloadend = () => {
                setFieldValue("logo", reader.result);
            };
            reader.readAsDataURL(file);

            const formData = new FormData()
            formData.append("entityName", 'AdminCustomer')
            formData.append("recordId", user?.userId)
            formData.append("label", 'logo')
            formData.append("files", file)

            dispatch(uploadImage(formData, (result) => {
                setFieldValue("logo", result.fileUrl)
            }))
        }
    };

    const onPressCreate = (values) => {
        let apiData = {
            customerName: values?.name,
            address: values?.address,
            contactName: data?.contactName,
            contactEmail: data?.contactEmail,
            contactPhone: data?.contactPhone,
            numberOfRooms: values?.rooms?.length ?? 0,
            numberOfStores: values?.stores?.length ?? 0,
            logo: values?.logo,
            rooms: (values?.rooms ?? []).map(room => ({
                roomId: room.roomId,
                distributionCenterId: room.distributionCenterId,
                roomName: room.roomName,
                createdBy: room.createdBy,
            })),
            stores: (values?.stores ?? []).map(store => ({
                storeId: store.storeId,
                storeName: store.storeName,
                createdBy: store.createdBy,
            })),
        };
        if (mode === 'edit') {
            apiData['customerId'] = data?.customerId;
            apiData['isActive'] = data?.isActive
            apiData['updatedBy'] = user?.userId
            dispatch(updateCustomer(apiData, () => navigate(-1)))
        }
        else {
            apiData['createdBy'] = user?.userId;
            dispatch(createCustomer(apiData, () => navigate(-1)))
        }
    }

    return {
        navigate,
        onPressCreate,
        handleImageChange,
        fileInputRef,
        common_loading
    }
}